import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { TextBoxModule, TextAreaModule, CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';

import { SharedModule } from '@shared/shared.module';
import { HttpClient } from '@angular/common/http';

import { CollectionsRoutingModule } from './collections-routing.module';
import { AuthenticationService } from '@core/services/authentication.serivce';

import { CollectionListComponent } from './collection-list/collection-list.component';
import { CollectionComponent } from './collection/collection.component';
import { CollectionOrganizationComponent } from './collection-organization/collection-organization.component';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { CollectionService } from './services/collection.service';
import { CollectionDocumentComponent } from './collection-document/collection-document.component';
import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';



@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    LayoutModule,
    TextBoxModule,
    LoaderModule,
    TextAreaModule,
    CheckBoxModule,
    DatePickerModule,
    UploadsModule,
    LabelModule,
    GridLayoutModule,
    GridModule, 
    ScrollViewModule,
    DropDownsModule,
    IconsModule,
    NotificationModule,
    DialogModule,
    InputsModule,
    FaIconComponent,
    SelectFieldComponent,
    DetailComponent,
    SearchComponent,
    TabStripModule,
    CollectionsRoutingModule
  ],
  declarations: [
    CollectionListComponent,
    CollectionComponent,
    CollectionOrganizationComponent,
    CollectionDocumentComponent
  ],
  providers: [AuthenticationService, CollectionService]
})
export class CollectionsModule { }
